export default "__VITE_PUBLIC_ASSET__3f668125__"